import styled, { css } from 'styled-components'
import { ToteEngagementModeEnum } from '@mote/api'
import { Block, Button, H5, Text } from '@mote/ui'

export const Response = styled(Block)(
  {
    padding: 8,
    borderRadius: 4,
    background: '#ffffff',
    border: '1px solid transparent',
    boxSizing: 'border-box'
  },
  getStylesForMode
)

function getStylesForMode(props) {
  const styleMap = {
    [ToteEngagementModeEnum.AFFIRMATIVE]: {
      borderColor: '#57c96a'
    },
    [ToteEngagementModeEnum.ASSISTIVE]: {
      borderColor: '#f4b400'
    }
  }
  return css(
    styleMap[props.mode] || {
      background: '#ececf3'
    }
  )
}

export const Container = styled(Block)`
  padding: 16px;
  border-radius: 8px;
  background: #f6f6f9;
  box-sizing: border-box;
`

export const ResponseText = styled(Text).attrs({
  tag: 'span',
  fontSize: 14,
  fontWeight: 400,
  color: '#6C6C84',
  alignment: 'left'
})`
  position: relative;
  padding-left: 28px;

  &::before {
    content: '';
    position: absolute;
    left: 12px;
    width: 1px;
    display: block;
    height: 100%;
    background: #ececf3;
  }
`

export const Header = styled(H5).attrs({
  fontSize: 14,
  fontWeight: 500,
  lineHeight: '120%',
  color: '#232323'
})({})

export const LinkButton = styled(Button).attrs({
  size: 'sm',
  variant: 'link'
})`
  & span.button-text {
    font-size: 14px;
  }
`
